import { Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-common-header',
  templateUrl: './common-header.component.html',
  styleUrls: ['./common-header.component.scss']
})
export class CommonHeaderComponent implements OnInit {
  user:any;
  userMenu:any;
  customConsumer:any
  emails: any;

  constructor() {
  }

  ngOnInit() {
    this.showRole();
  }

  showRole(){
    let userRolLogin =JSON.stringify(sessionStorage.getItem('userRole'));
    this.user=JSON.parse(userRolLogin);
    let customConsumers =JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer=JSON.parse(customConsumers); 
  }

   isMobileMenuOpen = false;

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }
}
